import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';
import { SvgIconComponent, injectRegisterIcons } from '@ngneat/svg-icon';
import { TranslatePipe } from '@ngx-translate/core';

import { AiThinkingPartVm } from '@domain/ai-assistant/ai-assistant.view-models';

import { MarkdownComponent } from '@shared/components/markdown/markdown.component';

import { appChevronDown16Icon } from '@icons/chevron-down-16';
import { appChevronUp16Icon } from '@icons/chevron-up-16';

@Component({
  selector: 'app-ai-thinking-part',
  imports: [SvgIconComponent, MarkdownComponent, TranslatePipe],
  templateUrl: './ai-thinking-part.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'flex flex-col' },
})
export class AiThinkingPartComponent {
  public part = input.required<AiThinkingPartVm>();

  public readonly collapsed = signal(true);

  constructor() {
    injectRegisterIcons([appChevronDown16Icon, appChevronUp16Icon]);
  }

  public toggleCollapsed(): void {
    this.collapsed.update((v) => !v);
  }
}
